const ITEMS = [
  "Pre-Launch Investments",
  "Resale Flats",
  "Premium Rentals",
  "Siddharth Vihar",
  "Wave City",
  "Aditya World City",
  "Noida Extension",
  "Trusted Since 2015",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className={`whitespace-nowrap font-serif text-3xl sm:text-4xl lg:text-5xl font-light px-8 ${i % 2 === 0 ? "text-outline-navy" : "text-navy-900/90"}`}>
          {item}
        </span>
        <span className="text-gold-500 text-xl" aria-hidden="true">&#9670;</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-navy-900/10 bg-cream py-10" aria-hidden="true">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
